




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import PeriodSimplifier from '../../../../../../PeriodSimplifier/PeriodSimplifier.vue'
import FieldTitle from '../../../../../../Pi/components/FieldTitle.vue'
import SwitchInput from '../../../../../../Pi/fields/SwitchInput/SwitchInput.vue'
import { FieldData } from '../../../../../../Pi/types'
import { TagData } from '../../../../../../Tags/types'
import SettingsMessageManager from '../../../logic/SettingsMessageManager'

@Component({
  components: {
    SwitchInput,
    FieldTitle,
    PeriodSimplifier,
  }
})
export default class MessageSettingsSendAfter extends Vue {
  @Prop() settingsMessageManager!: SettingsMessageManager

  @Prop() tariffTags!: Array<TagData>

  @Prop() disabled!: boolean

  isSettingVisible = false

  get context(): this {
    return this
  }

  get sendAfter(): boolean {
    return this.settingsMessageManager.fields.send_after > 0
  }

  sendAfterChange(arg: FieldData): FieldData {
    arg.setter = () => {
      if (this.settingsMessageManager.fields.send_after) {
        this.settingsMessageManager.setFieldValue('send_after', 0)
      } else {
        this.settingsMessageManager.setFieldValue('send_after', 1)
      }

      this.isSettingVisible = this.sendAfter
    }

    return arg
  }

  get value(): number {
    return this.settingsMessageManager.fields.send_after
  }

  set value(val: number) {
    this.settingsMessageManager.setFieldValue('send_after', val)
  }

  mounted() {
    this.isSettingVisible = this.sendAfter
  }
}
